import { useState } from 'react'

export const useDeleteModal = <
  T extends string | number | string[] | number[],
  P extends string | number | string[] | number[] = string,
>(): {
  closeDeleteModal: () => void
  openDeleteModal: (id: T, displayName?: P) => void
  isDeleteOpen: boolean
  deleteId?: T
  itemDisplayName?: P
} => {
  const [isDeleteOpen, setIsDeleteOpen] = useState<{
    visible: boolean
    id?: T
    itemDisplayName?: P
  }>({ visible: false })

  const closeDeleteModal = () => {
    setIsDeleteOpen({ visible: false })
  }
  const openDeleteModal = (id: T, displayName?: P) => {
    setIsDeleteOpen({ visible: true, id, itemDisplayName: displayName })
  }

  return {
    openDeleteModal,
    closeDeleteModal,
    isDeleteOpen: isDeleteOpen.visible,
    deleteId: isDeleteOpen.id,
    itemDisplayName: isDeleteOpen.itemDisplayName,
  }
}

export const useModal = useDeleteModal
